(() => {
  // すでに読み込み済みなら何もしない（重複対策）
  if (window.__ihCartAckInit) return;
  window.__ihCartAckInit = true;

  const KEY = 'ih_cart_ack_v1';
  const LANG_KEY = 'ih_cart_ack_lang_v1';

  // ローカルストレージの値（ここは今まで通り切り替え可能に）
  function getSavedChecked() {
    const saved = false; /* const saved = localStorage.getItem(KEY) === '1'; */
    return saved;
  }

  function getCartScopes() {
    return [
      document.querySelector('#CartDrawer'),
      document.querySelector('#main-cart-footer')
    ].filter(Boolean);
  }

  function setCheckoutEnabledIn(scope, enabled) {
    const buttons = [
      ...scope.querySelectorAll('button[name="checkout"]'),
      ...scope.querySelectorAll('#CartDrawer-Checkout'),
      ...scope.querySelectorAll('#checkout')
    ];

    buttons.forEach(btn => {
      btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', String(!enabled));
    });

    // 追加決済ボタンは「カート領域内だけ」隠す
    const dynamicAreas = scope.querySelectorAll(
      '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify-buttoncontainer]'
    );
    dynamicAreas.forEach(el => {
      el.style.display = enabled ? '' : 'none';
    });
  }

  function setCheckoutEnabledAll(enabled) {
    getCartScopes().forEach(scope => setCheckoutEnabledIn(scope, enabled));
  }

  function applyAckLang(root, lang) {
    // 同じ言語を何度も書き換えない（暴走予防）
    if (root.dataset.ihLangApplied === lang) return;
    root.dataset.ihLangApplied = lang;

    root.querySelectorAll('[data-ja][data-en]').forEach(el => {
      el.textContent = (lang === 'en') ? el.dataset.en : el.dataset.ja;
    });

    const btn = root.querySelector('.ih-cart-ack__toggle');
    if (btn) {
      const isEn = (lang === 'en');
      btn.textContent = isEn ? '日本語' : 'English';
      btn.setAttribute('aria-pressed', String(isEn));
    }
  }

  function bindOneAck(root) {
    const cb = root.querySelector('.ih-cart-ack__checkbox');
    const toggle = root.querySelector('.ih-cart-ack__toggle');

    const savedChecked = getSavedChecked();
    const savedLang = localStorage.getItem(LANG_KEY) || 'ja';

    if (cb && cb.dataset.ihBound !== '1') {
      cb.dataset.ihBound = '1';
      cb.checked = savedChecked;

      cb.addEventListener('change', () => {
        const checked = cb.checked;
        localStorage.setItem(KEY, checked ? '1' : '0');

        // 同じチェックUIが複数あっても同期
        document.querySelectorAll('.ih-cart-ack__checkbox').forEach(x => {
          x.checked = checked;
        });

        setCheckoutEnabledAll(checked);
      });
    }

    if (toggle && toggle.dataset.ihLangBound !== '1') {
      toggle.dataset.ihLangBound = '1';

      toggle.addEventListener('click', () => {
        const current = localStorage.getItem(LANG_KEY) || 'ja';
        const next = (current === 'en') ? 'ja' : 'en';
        localStorage.setItem(LANG_KEY, next);

        document.querySelectorAll('.ih-cart-ack').forEach(r => applyAckLang(r, next));
      });
    }

    // 初期適用（ここでボタン状態も整う）
    applyAckLang(root, savedLang);
  }

  function init() {
    const acks = document.querySelectorAll('.ih-cart-ack');
    if (!acks.length) return; // カートUIが無いページでは一切何もしない

    acks.forEach(bindOneAck);

    // 初期の購入ボタン制御
    setCheckoutEnabledAll(getSavedChecked());
  }

  // 暴走防止：observerからの呼び出しは間引き
  let scheduled = false;
  function scheduleInit() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      init();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();

    // 監視は “カートの中だけ”
    getCartScopes().forEach(target => {
      new MutationObserver(scheduleInit).observe(target, { childList: true, subtree: true });
    });
  });
})();
